import { InsuranceCompanyCode } from '../../../models/insurance-company-code.enum';
import {
  DictionaryMode,
  DictionaryRequestStrategy,
  InsurerDataMode,
  InsurerDataModeConfig, RequiredStrategy
} from './insurer-data-mode-config';
import {FieldType} from '../../../models/field-type';

export class InsurerDataSectionModeConfig {

  private readonly DEFAULT_CONFIG_KEY = 'DEFAULT';
  private companyCode: InsuranceCompanyCode;

  private config: { [key: string]: InsurerDataModeConfig } = {
    [this.DEFAULT_CONFIG_KEY]: {
      mode: InsurerDataMode.STANDARD
    },
    [InsuranceCompanyCode.LINK4]: {
      mode: InsurerDataMode.DICTIONARY,
      dictionaryMode: DictionaryMode.STATIC,
      cityConfig: {
        fieldType: FieldType.Select
      },
      streetConfig: {
        fieldType: FieldType.Select
      }
    },
    [InsuranceCompanyCode.MTU]: {
      mode: InsurerDataMode.DICTIONARY,
      dictionaryMode: DictionaryMode.DYNAMIC,
      dictionaryRequestStrategy: DictionaryRequestStrategy.DEBOUNCING,
      debounceTime: 500,
      cityConfig: {
        fieldType: FieldType.Select,
        searchTermMinLength: 1,
        typeForResultsMessage: 'INSURER_DATA_SECTION.ADDRESS_DATA_COMPONENT.typeForResultsMessage'
      },
      streetConfig: {
        fieldType: FieldType.Select,
        searchTermMinLength: 1,
        typeForResultsMessage: 'INSURER_DATA_SECTION.ADDRESS_DATA_COMPONENT.typeForResultsMessage',
        requiredStrategy: RequiredStrategy.NOT_REQUIRED
      }
    },
    [InsuranceCompanyCode.ERGO_HESTIA]: {
      mode: InsurerDataMode.DICTIONARY,
      dictionaryMode: DictionaryMode.DYNAMIC,
      dictionaryRequestStrategy: DictionaryRequestStrategy.DEBOUNCING,
      debounceTime: 500,
      cityConfig: {
        fieldType: FieldType.Select,
        searchTermMinLength: 1,
        typeForResultsMessage: 'INSURER_DATA_SECTION.ADDRESS_DATA_COMPONENT.typeForResultsMessage'
      },
      streetConfig: {
        fieldType: FieldType.Select,
        searchTermMinLength: 1,
        typeForResultsMessage: 'INSURER_DATA_SECTION.ADDRESS_DATA_COMPONENT.typeForResultsMessage',
        requiredStrategy: RequiredStrategy.NOT_REQUIRED
      }
    },
    [InsuranceCompanyCode.TUZ]: {
      mode: InsurerDataMode.DICTIONARY,
      dictionaryMode: DictionaryMode.STATIC,
      streetConfig: {
        fieldType: FieldType.TextField
      },
      isCountyRequired: true
    }
  };

  constructor(code: InsuranceCompanyCode) {
    this.companyCode = code;
  }

  getConfig(): InsurerDataModeConfig {
    return this.config[this.companyCode] ? this.config[this.companyCode] : this.config[this.DEFAULT_CONFIG_KEY];
  }
}
